import { render, staticRenderFns } from "./EventAddParticipantDialog.vue?vue&type=template&id=3d13853f&"
import script from "./EventAddParticipantDialog.vue?vue&type=script&lang=js&"
export * from "./EventAddParticipantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports